module.exports = __webpack_public_path__ + "img/search.41664a49.svg";